module.exports = __webpack_public_path__ + "img/mr_krabs.c693b47b.jpg";